define('Bootsgrid_Vfinance/js/product/finance',[
    "jquery"
], function ($) {
    'use strict';
    $.widget(
        'cubix.finance', {
        options: {},
        _create: function () {
            this._EventListener();
        },
        _EventListener: function () {
            var $widget = this;

            $('#v12_percent').change(function() {
                $('.v12depamounterror').html('');
                var v12_percent = $('#v12_percent option:selected').val();
                if(v12_percent == '') {
                    $('#show_v12_finance').hide();
                }
                else {
                    if($.isNumeric(v12_percent)) {
                        var proAmount = $('#product_total').val();
                        if(proAmount > 0) {
                            var dDeposit = (proAmount / 100) * v12_percent;
                            $('#custom_deposit').val(dDeposit.toFixed(2));
                        }
                    }
                    else {
                        $widget.validatedeposit();
                    }
                }
                $widget.loadFinance();
            });

            $('#custom_deposit').change(function() {
                $widget.validatedeposit();
            });

            $('#v12_pack').change(function(){
                $('#show_v12_finance').show();
                $widget.loadFinance();
            });

            $(document).on('click','#v12cal_finance',function(){
                $('.v12finace_box').slideToggle();
            });

            var v12_percent_default = $('#v12_pack option:last').val();
            $('#v12_pack').val(v12_percent_default);
        },
        validatedeposit: function() {
            var $widget = this;
            $('#v12_percent').val('Custom');
            var amount = $('#product_total').val();
            amount = parseFloat(amount);
            var min_percent = 10;
            var max_percent = 50;
            var mindeposit = (amount / 100) * min_percent;
            var maxdeposit = (amount / 100) * max_percent;
            mindeposit = mindeposit.toFixed(2);
            mindeposit = parseFloat(mindeposit);
            maxdeposit = Math.floor(maxdeposit*100)/100;
            maxdeposit = maxdeposit.toFixed(2);
            maxdeposit = parseFloat(maxdeposit);
            var deposit_entered = ($('#custom_deposit').val() != '') ? parseFloat($('#custom_deposit').val()) : 0;
            deposit_entered = deposit_entered.toFixed(2);
            var deposit_msg = '';
            if((deposit_entered > maxdeposit) || (deposit_entered < mindeposit)) {
                deposit_msg = '*Deposit amount should be between £'+mindeposit+' and £'+maxdeposit+'.';
                $('#show_v12_finance').hide();
            }
            else{
                $('#show_v12_finance').show();
                $widget.loadFinance();
            }
            $('.v12depamounterror').html(deposit_msg);
        },
        loadFinance: function(a) {
            var proAmount = parseFloat($('#product_total').val());
            var v12_dpercent = $('#v12_percent').val();
            var minfinance = parseFloat($('#minfinance').val());
            var maxfinance = parseFloat($('#maxfinance').val());
            
            if(proAmount > 0 && proAmount >= minfinance && proAmount <= maxfinance) {
                if(v12_dpercent=='Custom') {
                    var dDeposit = ($('#custom_deposit').val() != '') ? parseFloat($('#custom_deposit').val()) : 0;
                }
                else {
                    var dDeposit = (proAmount / 100) * v12_dpercent;
                    if(v12_dpercent == 50) {
                        var dDeposit = Math.floor(dDeposit*100)/100;
                    }
                    $('#custom_deposit').val(dDeposit.toFixed(2));
                }

                var v12_dloan_amt = proAmount - dDeposit;
                var v12_dinterest = 0.03459;
                var v12_dmonthly_payment = v12_dloan_amt * v12_dinterest;
                $('.v12_montly_pay_cart').html('£'+v12_dmonthly_payment.toFixed()+'.00');
                var v12_pack_txt = $('#v12_pack option:selected').text();
                var v12_interest = $("#v12_pack option:selected").attr('data-interest');
                var v12_apr = $("#v12_pack option:selected").attr('data-apr');
                var v12_months = $("#v12_pack option:selected").attr('data-month');
                var v12_monthly_payment = v12_dloan_amt * v12_interest;
                var v12_total_amount_payable = v12_monthly_payment * v12_months;
                var v12_cost_of_loan = Math.abs(v12_total_amount_payable - v12_dloan_amt);

                if (v12_dloan_amt >= 250) {
                    $('#show_v12_finance').show();
                    $('#v12_pack_name').html(v12_pack_txt);
                    $('#v12_cart_val').html('£'+proAmount);
                    $('#v12_deposit_amt').html('£'+dDeposit.toFixed(2));
                    $('#v12_loan_amt').html('£'+v12_dloan_amt.toFixed(2));
                    $('#v12_interest_rate').html(v12_apr+'%');
                    if(v12_apr == 0) {
                        $('.roi').hide();
                        $('.roi.null').show();
                    }
                    else {
                        $('.roi').hide();
                        $('.roi.fixed').show();
                    }
                    $('.v12_montly_pay_cart').html('£'+v12_monthly_payment.toFixed(2));
                    $('#v12_montly_pay').html('£'+v12_monthly_payment.toFixed(2));
                    $('#v12_payments').html(v12_months);
                    $('#v12_cost_credit').html('£'+v12_cost_of_loan.toFixed(2));
                    $('#v12_total_cost').html('£'+v12_total_amount_payable.toFixed(2));
                }
                $('.finance-btn-alias').show();
            }
            else {
                $('.finance-btn-alias').hide();
            }
        }
    });
    return $.cubix.finance;
});
